module.exports = __webpack_public_path__ + "static/media/new.617077d1.svg";